import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {Alert as Alert2, Col, Row} from 'reactstrap';
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {isValidPayTrOrder} from "../../common/componentValidation";
import DefaultModal from "../invoice/DefaultModal";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle,} from 'react-accessible-accordion';
import {request} from "../../helper/APIUtils";
import {Decimal} from 'decimal.js';
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import ReactLoading from "react-loading";
import {VirtualHost} from "../../constants";
import moment from "moment";

class ExternalPayTrModal extends Component {

	constructor(props) {
		super(props);
		this.state 		= {
			unitPrice:0,
			error: {},
			order:{},
			orderList:[],
			customerList:[],
			vknList:[],
			saveLoading:false,
			couponCode: undefined,
			acceptMbt24Coupon: false
		};
		this.getList 	= this.getList.bind(this);
		this.save 		= this.save.bind(this);
		this.remove 		= this.remove.bind(this);
		this.acceptCoupon 		= this.acceptCoupon.bind(this);
	}

	componentWillMount() {
		this.setState({customerList:this.props.customerList});
		this.getList();
	}

	getList(){
		this.setState({modal: this.props.modal});
		let self = this;
		let params = {
			url:"/payTrOrder/getExternalOrderList",
			method: "post"
		};
		self.setState({loading: true});
		request(params)
		.then(function (response) {
			let {unitPrice,orderList} = response.data;
			let vknList = [];
			for(let i=0;i<orderList.length;i++){
				let order = orderList[i];
				if(order.status===2){
					let customerList = JSON.parse(order.vknJson);
					for(let j=0;j<customerList.length;j++){
						vknList.push(customerList[j].vknTckn);
					}
				}
			}
			console.log("vknList",vknList);
			console.log("orderList",orderList);
			self.setState({unitPrice,orderList,vknList,loading:false});
		}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({loading: false});
		});
	}

	save(e) {
		e.preventDefault();
		let {customerList,unitPrice} = this.state;
		let customers = customerList.map(customer => ({
			recordId: customer.recordId,
			customerName: customer.customerName,
			vknTckn:customer.vknTckn
		}));
		let totalPrice = customerList.length * unitPrice;
		let order = this.state.order;
		order["merchantFailUrl"]  = window.location.origin + "/accounting/customer";
		order["merchantOkUrl"]    = window.location.origin + "/accounting/customer";
		order["vknJson"] 		  = JSON.stringify(customers);
		order["payTrOrderLines"]  = [{unit: 88, count: 0, price:totalPrice}]
		order["couponCode"] = this.state.acceptMbt24Coupon ? "mbt24" : null;
		order["paymentType"] =  "EXTERNAL_PAYMENT";
		let result = isValidPayTrOrder(order);
		let valid = result.valid;
		if (valid) {
			let self = this;
			let params = {
				url:"/payTrOrder/save",
				method: "post",
				data: order
			};
			self.setState({saveLoading: true});
			request(params)
			.then(function (response) {
				let order = response.data;
				Alert.success("Sepete eklendi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
				self.setState({order},()=> self.getList());
				setTimeout(function () {
					self.setState({saveLoading:false});
					window.location.href = self.props.paytrDomain + "/external/"+order.merchantOid;
				}, 100);
			}).catch(function (error) {
				showAxiosError(error);
			}).then(function () {
				self.setState({saveLoading: false});
			});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.setState({saveLoading:false});
		}
	}

	remove(index) {
		let customerList = deepCopyObject(this.state.customerList);
		customerList.splice(index, 1);
		this.setState({customerList});
	}

	getStatusColor(status) {
		let color = "";
		switch (status) {
			case 0:
				color="#FF5733";
				break;
			case 1:
				color="#101357";
				break;
			case 2:
				color="#3d7c47";
				break;
			case 3:
				color="#E5310A";
				break;
			default:
				color="";
				break;
		}
		return color;
	}

	modifyDate(date) {
		return moment(date).format('DD-MM-YYYY HH:mm:ss');
	}

	getStatusText(payTrOrder) {
		let result = "";
		let status = payTrOrder.status;
		switch (status) {
			case 0:
				result=<label style={{fontWeight: 'bold'}}><a href={ this.props.paytrDomain + "/external/"+payTrOrder.merchantOid}>{payTrOrder.explanation}</a></label>;
				break;
			case 1:
				result=<label style={{color: 'black', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
				break;
			case 2:
				result=<label style={{color: '#3d7c47', fontWeight: 'bold'}}>{payTrOrder.explanation} {payTrOrder.updatedAt ? this.modifyDate(payTrOrder.updatedAt) : this.modifyDate(payTrOrder.createdAt)}</label>;
				break;
			case 3:
				result=<label style={{color: '#E5310A', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
				break;
			default:
				result=<label style={{color: '#D6DBDF', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
				break;
		}
		return result;
	}

	acceptCoupon() {
		if (VirtualHost.conf.resourcePrefix === "faturam24" && !this.state.acceptMbt24Coupon && this.state.couponCode && (this.state.couponCode === "MBT24" || this.state.couponCode === "mbt24")) {
			let unitPrice = this.state.unitPrice - 24;
			this.setState({unitPrice: unitPrice, couponCode: '', acceptMbt24Coupon: true});
		}
	}

	render() {
		let result = this.state.customerList.length * this.state.unitPrice;
		result = new Decimal(new Decimal(result+ result * 0.20).toFixed(2)).toNumber();
		return (
			<DefaultModal
				disabled={this.state.saveLoading}
				isOpen={this.props.modal}
				title="Kontör Talep Takibi"
				size="lg"
				confirmBtnText=""
				cancelBtnText="Kapat"
				onConfirm={() => this.props.toggle(false)}
				onCancel={() => this.props.toggle(false)}>
				<Col sm="12">
					<Col sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
						<div className="card-body" style={{padding: '1em 1em 1em 1em'}}>
							<div className="row">
								<div className="col-sm-12">
									<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
										<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '35%', marginTop: 20}}>
											<div style={{width: '15px', height: '15px', background: '#ffd86b', margin: '0 3px'}}/>
											<label style={{margin:0, paddingLeft:5}}>Daha önce ödeme yapılmış</label>
										</div>
									</div>
								</div>
								<div className="col-sm-12">
									<table className="" style={{textAlign: 'center'}}>
										<thead>
											<tr style={{backgroundColor: '#ebedf0'}}>
												<th width="2%">#</th>
												<th width="7%">VKN/TCKN</th>
												<th width="7%">Unvan</th>
												<th width="7%">Fiyat</th>
												<th width="7%">KDV(20)</th>
												<th width="3%">İşlemler</th>
											</tr>
										</thead>

										{this.state.loading ?
										<tbody>
											<tr>
												<td colSpan="6">
													<ReactLoading type="spinningBubbles" style={{
														width: "70px",
														height: "70px",
														margin: "20px auto 0 auto",
														fill: "#888"
													}}/>
												</td>
											</tr>
										</tbody>
										:
										<tbody>
										{this.state.customerList.map((customer, index) =>
											<tr key={"customer" + index} className={this.state.vknList.includes(customer.vknTckn) ? "expiring-credit-row" : ""}>
												<td>{index + 1}</td>
												<td>
													{customer.vknTckn}
												</td>
												<td>
													<TextOverFlowTooltip text={customer.customerName} maxLength={20}/>
												</td>
												<td>
													{new Decimal(this.state.unitPrice) + " ₺"}
												</td>
												<td>
													{new Decimal(this.state.unitPrice * 0.20).toFixed(2) + " ₺"}
												</td>
												<td>
													{this.state.customerList.length > 1 &&
													<button type="button" className="Btn temizle"
															style={{margin: "0", background: '#FFCCCC'}}
															onClick={() => this.remove(index)}>
													</button>
													}
												</td>
											</tr>
										)}
										</tbody>
										}
									</table>
								</div>
								<Col sm="12">
									<p style={{float:"right"}}>Toplam Tutar: {result}₺</p>
								</Col>
							</div>
							<div className="row">
								<div className="col-sm-12">
									{VirtualHost.conf.resourcePrefix === "faturam24" &&
									<div className="col-sm-12 coupon-container"
										 style={{position: 'absolute', bottom: 0}}>
										<label className="mr-3">Kupon Kodu :</label>
										<input className="mr-3" type="text" placeholder="" style={{width: '200px'}}
											   value={this.state.couponCode}
											   onChange={(e) => this.setState({couponCode: e.target.value})}/>
										<button type="button"
												style={{background: '#c2d4d8', marginRight: '0px'}}
												disabled={this.state.saveLoading}
												className="TekBtn kaydet"
												onClick={this.acceptCoupon}>Kuponu Uygula
										</button>
									</div>}
									<button type="button"
											style={{padding: '9px 39px 9px 13px', float: 'right', background:'#c2d4d8', marginRight:'0px'}}
											disabled={this.state.saveLoading}
											className="col-sm-21 TekBtn"
											onClick={this.save}>Ödeme Yap
									</button>
								</div>
							</div>
						</div>
					</Col>
                    {(this.state.orderList && this.state.orderList.length>0) &&
                        <Col sm="12" style={{paddingBottom:"10px",
                                             marginTop:"10px",
                                             border: "2px solid #e7e7e7",
                                             borderRadius: "6px 6px 6px 6px"}}>
                            <h6 style={{marginLeft:"10px", marginTop:"10px", textTransform:"none"}}>Ödeme Takibi</h6>
                            <Accordion>
                                {this.state.orderList.map((order, index) =>
                                    <AccordionItem key={"accordion-item-"+index}>
										<AccordionItemTitle style={{border: this.getStatusColor(order.status)}}>
											<div className='col-sm-12 row'>
												<div className="accordion__arrow" role="presentation" />
												<div className='col-sm-6 row'>
													<h6 className="u-position-relative"
														style={{margin:"0px",marginLeft:"10px", textTransform:"none"}}>{(index+1) +". Ödenecek Tutar: " +order.totalPrice + '₺'}
													</h6>
												</div>
												<div className='col-sm-6 row' style={{paddingLeft: '45px'}}>
													{this.getStatusText(order)}
												</div>
											</div>
                                        </AccordionItemTitle>
                                        <AccordionItemBody>
											<div style={{margin: '0 0 16px 0'}}>
												{JSON.parse(order.vknJson).map((customer, index) =>
													<Alert2 style={{backgroundColor: "#d4edda", borderColor: "#c3e6cb",color:"#155724",padding:"8px", display:''}} key={"payTrOrderLine"+index}>
														{(index+1) +". "+ customer.vknTckn} {<TextOverFlowTooltip text={customer.customerName} maxLength={30}/>} {new Decimal(new Decimal(order.totalPrice/(JSON.parse(order.vknJson).length)).toFixed(2)).toNumber()} ₺
													</Alert2>)
												}
												<Col sm="12" style={{padding:'0px'}}>
													<p style={{float:"right", padding:'0px'}}>Toplam Tutar: {new Decimal(new Decimal(order.totalPrice).toFixed(2)).toNumber()}₺</p>
												</Col>
											</div>
                                        </AccordionItemBody>
                                    </AccordionItem>)
                                }
                            </Accordion>
                        </Col>
                    }
				</Col>
			</DefaultModal>
		);
	}
}

export default ExternalPayTrModal;

